module.exports = __webpack_public_path__ + "img/denglu-beijing@2x.4fd33f75.png";